const getActiveClientReservationIdsForChat = (clientReservations = [], now = Date.now()) => {
  const activeIds = (clientReservations || [])
    .filter((reservation) => {
      const startDate = Number(reservation?.startDate);
      const endDate = Number(reservation?.endDate);

      if (!Number.isFinite(startDate) || !Number.isFinite(endDate)) return false;

      return startDate <= now && endDate >= now;
    })
    .map((reservation) => reservation?.uid)
    .filter(Boolean);

  return new Set(activeIds);
};

const chatUtils = {
  getActiveClientReservationIdsForChat,
};

export default chatUtils;
